var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('van-overlay',{attrs:{"show":_vm.show,"z-index":2100}},[_c('div',{staticClass:"loading-container"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_vm._v(_vm._s(_vm.text))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }